export enum AppointmentTypeEnum {
    Permanent = 1,
    Visit     = 2,
    Route     = 3,
    VisitAlt  = 7,
}
